import { api } from "./api"

export const lessonService = {
    get: params => api.get("/school/lessons/", { params }),
    post: data => api.post("/school/lessons/", data),
    patch: data => api.patch(`/school/lessons/${data.id}/`, data),
    delete: data => api.delete(`/school/lessons/${data.id}/`).then(() => ({ data })),
    deleteMany: data => api.post(`/school/lessons/delete_lessons/`, data).then(() => ({ data: data.lessons })),
    copy: data => api.post("/school/lessons/copy_lesson/", data)
}

export const logBookService = {

    get: params => api.get("/school/logbook/", { params }),
    getStudentLogBook: params => api.get("/school/logbook_for_student/", { params }),

    getItems: params => api.get("/school/logbook_item/", { params }),
    postItems: data => api.post("/school/logbook_item/", data),
    patchItems: data => api.patch(`/school/logbook_item/${data.id}/`, data),
    deleteItems: data => api.delete(`/school/logbook_item/${data.id}/`).then(() => ({ data })),
}

export const employeeService = {
    getGroupSubjects: params => api.get("/school/groups_for_employee/", { params })
}

export const taskService = {
    get: params => api.get("/school/task/", { params }),
    getById: id => api.get(`/school/task/${id}/`),
    post: data => api.post("/school/task/", data),
    patch: data => api.patch(`/school/task/${data.id}/`, data),
    addFile: data => api.post(`/school/task/${data.id}/add_file/`, data),
}

export const fileService = {
    post: async file => {
        const formData = new FormData()
        formData.append("file", file, file.name)
        const config = { headers: { "Content-Type": "multipart/form-data" } }
        return api.post(`/files/`, formData, config).then(res => res.data)
    }
}

export const lessonMaterialService = {
    get: lesson => api.get("/school/lesson_material/", { params: { lesson } }),
    getById: id => api.get(`/school/lesson_material/${id}/`),
    post: data => api.post("/school/lesson_material/", data),
    patch: data => api.patch(`/school/lesson_material/${data.id}/`, data),
    addFile: data => api.post(`/school/lesson_material/${data.id}/add_file/`, data),
}

export const finalMarkLogBookService = {
    get: params => api.get("/school/final_mark_logbook/", { params }),
    getById: id => api.get(`/school/final_marks/${id}/`),
    post: data => api.post("/school/final_marks/", data),
    patch: data => api.patch(`/school/final_marks/${data.id}/`, data),
}

export const getTimetable = params => api.get("/school/timetable/lessons/", { params })

export const planService = {
    get: params => api.get("/school/calendar_plans/", { params }),
    post: async data => {
        console.log(data)
        const formData = new FormData()
        formData.append("file", data.file, data.file.name)
        formData.append("name", data.name)
        const config = { headers: { "Content-Type": "multipart/form-data" } }
        return api.post(`/school/calendar_plans/`, formData, config)
    },
    patch: data => {
        const formData = new FormData()
        formData.append("file", data.file, data.file.name)
        formData.append("name", data.name)
        const config = { headers: { "Content-Type": "multipart/form-data" } }
        return api.patch(`/school/calendar_plans/${data.id}/`, formData, config)
    },
    delete: data => api.delete(`/school/calendar_plans/${data.id}/`).then(() => ({ data }))
}
